import * as React from 'react';

import { Button } from '@lightspeed/flame/Button';
import { FlameTheme } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import { OverlayDiv } from './AnalyticsLoader.style';

type Props = {
  onReload: () => void;
};

export const ErrorCell: React.FC<Props> = ({ onReload }) => {
  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <div style={{ minHeight: '150px' }} />
      <OverlayDiv>
        <div>
          <FlameTheme>
            <Text
              mb="2"
              fontSize="12px"
              fontWeight={400}
              lineHeight="14px"
              color="#020203"
              className="analytics_error_label"
            >
              Unable to load table.
              <br />
              Refresh the data to try again.
            </Text>
            <Button type="button" onClick={onReload}>
              Refresh data
            </Button>
          </FlameTheme>
        </div>
      </OverlayDiv>
    </div>
  );
};
